<script setup lang="ts">
import { RouterView } from 'vue-router';
</script>

<template>
  <a class="skip-link" href="#main">Skip to the machine</a>
  <RouterView />
</template>

<style scoped>
.skip-link {
  position: absolute;
  left: var(--sp-4);
  top: -3rem;
  padding: var(--sp-2) var(--sp-3);
  background: var(--c-accent);
  color: var(--c-accent-text);
  border-radius: var(--radius);
  z-index: 10;
}

.skip-link:focus {
  top: var(--sp-4);
}
</style>
